import axios from 'axios';
import store from '../../store';

const model = () => {
	return {
		new_id:			'',
		username: 		'',
		password: 		'',
		note: 			'',
	};
};

const assignModel = () => {
	return {
		organisationId:	'',
	};
};

const updateModel = () => {
	return {
		toVersion:	'',
	};
};

const save = async (model) => {
	if (model.password === '') delete model.password;

	try {
		return model.id ? await axios.put(`/devices/${model.id}`, { ...model, id: model.new_id }) : await axios.post(`/devices`, { ...model, id: model.new_id });
	} catch (err) {
		return false;
	}
};

const read = async(id) => {
	return (await axios.get(`/devices/${id}`)).data;
};

const window = async (model, submit) => {
	store.dispatch('win/push', {
		component: 	'client-window-view',
		model:		model,
		async submit(model) {
			return await submit(model);
		}
	});
};

const send = async (model, submit) => {
	store.dispatch('win/push', {
		component: 	'send-window-view',
		model:		model,
		async submit(model) {
			return await submit(model);
		}
	});
};

const open = async (id, onSave) => {
	window(id ? await read(id) : model(), async (model) => {
		const r = await save(model);

		if (r) {
			if (onSave) onSave(r);
			return true;
		}

		return false;
	});
};

const assign = async (id, submit) => {
	store.dispatch('win/push', {
		component: 	'assign-window-view',
		model:		assignModel,
		async submit(model) {
			await axios.put(`/devices/${id}/organisation`, model.organisationId, {
				headers: {
					'Content-Type': 'text/plain'
				},
			});

			return await submit(model);
		}
	});
};

const update = async (id, submit) => {
	store.dispatch('win/push', {
		component: 	'update-window-view',
		model:		updateModel,
		async submit(model) {
			await axios.put(`/devices/${id}/version/update`, model.toVersion, {
				headers: {
					'Content-Type': 'text/plain'
				},
			});

			return await submit(model);
		}
	});
};

const del = async (id) => {
	await axios.delete(`/devices/${id}`);
};

const openMigration = async () => {
	store.dispatch('win/push', {
		component: 	'client-migration-window-view',
		async submit(model) {
			return await submit(model);
		}
	});
};

export default {
	model,
	updateModel,
	assignModel,
	save,
	read,
	open,
	window,
	del,
	send,
	assign,
	update,
	openMigration,
};